import { render } from "./TableItemTags.vue?vue&type=template&id=28e8acdc&ts=true"
import script from "./TableItemTags.vue?vue&type=script&lang=ts"
export * from "./TableItemTags.vue?vue&type=script&lang=ts"

import "./TableItemTags.vue?vue&type=style&index=0&id=28e8acdc&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__